const generateSubIssueText = (issue: SummaryIssue) => {
  return issue.sub_issues.reduce((subAcc, subIssue) => {
    return subAcc + `${subIssue.title} (${subIssue.feedback_count}) `;
  }, '');
};

const generateIssueText = (
  issues: SummaryIssue[],
  prefix: string,
  suffix: string,
) => {
  return issues.reduce((acc, issue, index) => {
    const text = `${index + 1}. ${issue.title} (${issue.feedback_count})\n${
      issue.summary
    } ${prefix} ${generateSubIssueText(issue)} ${suffix}\n\n`;
    return acc + text;
  }, '');
};

const searchSummaryUtils = {
  generateSubIssueText,
  generateIssueText,
};

export default searchSummaryUtils;
